import { invariant } from '@epic-web/invariant'
import { useUserStore } from '~/app/_store/user-store'
import { useReplicacheQueryV2 } from '~/hooks-data/use-replicache-query'
import { useTeamReplicache } from '~/hooks-data/use-team-replicache'
import { teamSpaceMutators } from '@basehub/data/replicache/mutators/team-space/mutators'

export const useNotifications = () => {
  const replicache = useTeamReplicache().data?.replicache
  const currentUserId = useUserStore((s) => s.optimisticUser?.id)

  const { data: notifications } = useReplicacheQueryV2({
    replicache,
    async fetcher(tx) {
      invariant(currentUserId, 'currentUserId should be defined')
      return await teamSpaceMutators
        .listNotificationsByUser(tx, currentUserId)
        .then((notifications) => {
          return [...notifications].sort((a, b) => {
            return (
              new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
            )
          })
        })
    },
    key: ['notifications', currentUserId],
    enabled: !!replicache,
  })

  return {
    notifications,
  }
}
